import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in St. Petersburg?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk can take 1–3 months, especially during busy travel seasons.",
  },
  {
    q: "Do I need to visit the Tampa office?",
    a: "Most travelers start online and ship their documents via overnight courier — no office visit required. Our closest office is in Tampa at 400 N Ashley Dr #1700, about 25 miles northeast via I-275. It is by appointment only. Please start your order online first so we can confirm eligibility, provide your checklist, and schedule your visit if needed.",
  },
  {
    q: "I'm going on a cruise from Port Tampa Bay — do I need a passport?",
    a: "For international cruises departing Port Tampa Bay (~25 miles from St. Petersburg), a full U.S. passport book is strongly recommended. While some closed-loop cruises may allow a birth certificate and government ID, a passport book is the safest option and required if you need to fly home from a foreign port in an emergency.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Can I get an expedited passport if I've never had one before?",
    a: "Yes, but first-time applicants typically require an in-person acceptance clerk visit before documents can be submitted for expedited processing. We guide you through exactly what to do and where to go in the Pinellas County area.",
  },
  {
    q: "What is the closest passport agency to St. Petersburg?",
    a: "The closest regional passport agency to St. Petersburg is the Miami Passport Agency, located at 1501 Biscayne Blvd, Suite 210, Miami, FL 33132 — approximately 265 miles from St. Petersburg, about a 4 hour drive via I-75. That agency only serves documented life-or-death emergencies by appointment — it is not available for standard expedited requests. Fast Passport Center's courier service is the fastest accessible alternative for St. Petersburg travelers without the drive.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
  {
    q: "What if I need a child passport in St. Petersburg?",
    a: "Child passports (for minors 15 and under) require parental participation and an in-person acceptance step — both parents typically must consent. We provide clear instructions and a checklist so you know exactly what to do. Expedited processing options are available after the acceptance step.",
  },
  {
    q: "Can I fly internationally from St. Pete–Clearwater International Airport (PIE)?",
    a: "PIE primarily serves domestic routes with limited international connections. Most St. Petersburg international travelers fly from Tampa International Airport (TPA), about 25 miles away. A valid passport is required for all international flights regardless of which airport you depart from.",
  },
  {
    q: "Does Fast Passport Center serve all of Pinellas County?",
    a: "Yes — we serve St. Petersburg, Clearwater, Largo, Pinellas Park, Seminole, Gulfport, Treasure Island, St. Pete Beach, Pass-a-Grille, Madeira Beach, Indian Rocks Beach, and all communities in Pinellas County. Start online, ship overnight, and we handle the rest.",
  },
  {
    q: "Where can I get an emergency passport in St. Petersburg today?",
    a: "The only same-day option is a regional passport agency appointment — and the nearest one to St. Petersburg is the Miami Passport Agency at 1501 Biscayne Blvd, Suite 210, Miami, FL 33132, approximately 265 miles away. Those appointments are reserved for life-or-death emergencies only and walk-ins are not accepted. For most St. Petersburg travelers, Fast Passport Center's registered courier service is the fastest realistic option — processing in as little as 2–3 business days with no agency visit required. Start your order and we'll confirm your timeline based on your departure date.",
  },
  {
    q: "What is the fastest way to get a passport in St. Petersburg?",
    a: "The fastest option available to most St. Petersburg travelers is Fast Passport Center's 2–3 business day courier service. You ship your documents overnight, we submit through our reserved courier access, and your passport is returned to you. No 4+ hour drive to Miami, no appointment needed, no waiting in line. For true life-or-death emergencies only, a regional agency appointment may be available but eligibility is strict.",
  },
  {
    q: "Can I get a same-day passport in St. Petersburg?",
    a: "Same-day processing is only available through a regional passport agency for documented life-or-death emergencies — and the nearest agency to St. Petersburg requires a confirmed appointment and is approximately 265 miles away in Miami. For most travelers, same-day is not a realistic option. Fast Passport Center can process your passport in as little as 2–3 business days — the fastest option available without an agency appointment.",
  },
  {
    q: "Is there a passport agency in St. Petersburg?",
    a: "St. Petersburg does not have its own regional passport agency. The closest is the Miami Passport Agency located in Miami, approximately 265 miles from St. Petersburg. That agency only serves documented life-or-death emergencies by appointment — it is not available for standard expedited requests. Fast Passport Center's courier service gives St. Petersburg travelers a faster and more accessible alternative with no drive required.",
  },
  {
    q: "What if I can't get a St. Petersburg passport agency appointment?",
    a: "Regional passport agency appointments are routinely unavailable weeks out and are restricted to life-or-death emergencies only. If you searched for an appointment and couldn't get one, Fast Passport Center's registered courier channel is your fastest next step — no appointment needed, processing as little as 2–3 business days, and you never have to leave St. Petersburg. Start your order and we'll confirm your timeline.",
  },
];

export default function StPetersburgFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything St. Petersburg travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}